import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';

import { FORM_STEPS } from './../../shared/index';

import { NavService } from './navigation.service';

@Component({
  selector: 'pax-cf-nav',
  styles: [require('./navigation.component.sass')],
  template: require('./navigation.component.html'),
})
export class NavigationComponent implements OnInit, OnDestroy {
  payload;
  formSteps;
  storeData;

  constructor(
    private _store: Store<any>,
    private _ns: NavService
  ) {}

  isCompleted(stepId) {
    return this._ns.completedSteps.includes(stepId);
  }

  isActive(stepId) {
    return this._ns.activeStep === stepId;
  }

  isInactive(stepId) {
    return this._ns.inactiveSteps.includes(stepId);
  }

  ngOnInit() {
    this.formSteps = FORM_STEPS;
    this.storeData = this._store.select('cvform').subscribe(data => this.payload = data);
  }

  ngOnDestroy() {
    this.storeData.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/coverage-form/navigation/navigation.component.ts